import Agent from "../services/RequestInstance";
import { ServerError } from "../utils/helpers";

import config from "../config/Config";

const BACKEND_URL = config.BACKEND_URL;

function fetchCategory(payload, cb) {
  Agent.fire("get", `${BACKEND_URL}/admin/allCategories`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function fetchSubCategory(payload, cb) {
  Agent.fire("get", `${BACKEND_URL}/admin/allSubCategories`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function fetchServices(payload, cb) {
  Agent.fire("get", `${BACKEND_URL}/admin/allServices`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}

function addCategory(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/addCategory`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function updateCategory(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/updateCategory`)
    .send(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function deleteCategory(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/deleteCategory`)
    .send(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function multi(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/toggleMulti`)
    .send(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function feature(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/toggleFeature`)
    .send(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function updateService(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/updateService`)
    .send(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
export default {
  fetchCategory,
  addCategory,
  updateCategory,
  deleteCategory,
  fetchSubCategory,
  fetchServices,
  multi,
  feature,
  updateService
};
